<template>
    <div
        class="field-item"
        :class="[
            solid ? 'is-solid' : '',
            disabled ? 'is-disabled' : '',
            alignRight ? 'is-align-right' : '',
            isInputFocus ? 'is-focus' : '',
        ]"
    >
        <div class="field-item-content">
            <div class="field-item-left" v-if="$slots.left">
                <slot name="left"></slot>
            </div>
            <label class="field-item-title" v-if="title">
                {{ title }}
            </label>
            <div class="field-item-control">
                <input
                    class="input-item-input"
                    :placeholder="placeholder"
                    :type="type"
                    :disabled="disabled"
                    :readonly="readonly"
                    v-model="inputBindValue"
                    @focus="handleFocus"
                    @blur="handleBlur"
                />
            </div>
            <div class="field-item-right" v-if="addon || $slots.right">
                <slot name="right">
                    {{ addon }}
                </slot>
            </div>
        </div>
        <div class="field-item-children" v-if="$slots.children">
            <slot name="children"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FieldItem',
        inject: {
            rootField: {
                from: 'rootField',
                default() {
                    return {}
                }
            },
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: '',
            },
            content: {
                type: String,
                default: '',
            },
            addon: {
                type: String,
                default: '',
            },
            solid: {
                type: Boolean,
                default: false,
            },
            alignRight: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                isInputFocus: false,
                value: ''
            };
        },
        computed: {
            currentDisabled() {
                return this.rootField.disabled || this.disabled;
            }
        },
        watch: {
            value(val) {
                if (val !== this.inputValue) {
                    this.inputValue = this.value;
                }
            }
        },
        methods: {
            handleFocus() {
                this.isInputFocus = true;
                this.$emit('focus', this.name);
            },
            handleBlur() {
                setTimeout(() => {
                    this.isInputFocus = false;
                    this.$emit('focus', this.name);
                }, 100);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .field-item {
        position: relative;

        &-title {
            flex-shrink: 0;
            font-size: 28px;
        }
        &-left {
            flex-shrink: 0;
        }
        &-content {
            position: relative;
            display: flex;
            min-height: 100px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1PX solid #E5E5E5;
            font-size: 28px;
        }
        &-title {
            padding-right: 20px;
            color: #333;
        }
        &-control {
            flex: 1;
        }
        .input-item-input {
            width: 100%;
            height: 100px;
            border: none;
            line-height: 100px;
            text-align: right;
            color: #333;
        }
        &.is-focus {
            .field-item-content {
                border-color: #333;
            }
        }
        &.is-disabled {
            .input-item-input {
                color: #858b9c;
                background-color: white;
            }
            .field-item-content {
                border-color: #E5E5E5;
            }
        }
    }
</style>